import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scissors, Droplet, Wind, Sparkles, X, Clock, Plus, Package, ChevronRight, Palette, Zap, Heart, Flower2 } from 'lucide-react';
import { API_BASE, getImageUrl } from '../config';

const DEFAULT_IMAGES = {
    haircut: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=800&q=80',
    coloring: 'https://images.unsplash.com/photo-1560869713-7d0a29430803?auto=format&fit=crop&w=800&q=80',
    balayage: 'https://images.unsplash.com/photo-1595476108010-b4d1f8c2b1b1?auto=format&fit=crop&w=800&q=80',
    lissage: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?auto=format&fit=crop&w=800&q=80',
    styling: 'https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&w=800&q=80',
    treatment: 'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?auto=format&fit=crop&w=800&q=80',
    pack: 'https://images.unsplash.com/photo-1631214500115-598fc2cb8d2d?auto=format&fit=crop&w=800&q=80',
    massageDetente: 'https://images.unsplash.com/photo-1544161515-4af6b1d462c2?auto=format&fit=crop&w=800&q=80',
    massageSoins: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=800&q=80',
    extras: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=800&q=80'
};

const CATEGORIES = [
  { id: 'Scissors', key: 'haircut', icon: Scissors },
  { id: 'Droplet', key: 'coloring', icon: Droplet },
  { id: 'Palette', key: 'balayage', icon: Palette },
  { id: 'Zap', key: 'lissage', icon: Zap },
  { id: 'Wind', key: 'styling', icon: Wind },
  { id: 'Sparkles', key: 'treatment', icon: Sparkles },
  { id: 'Package', key: 'pack', icon: Package },
  { id: 'Heart', key: 'massageDetente', icon: Heart },
  { id: 'Flower2', key: 'massageSoins', icon: Flower2 },
  { id: 'Plus', key: 'extras', icon: Plus },
];

export default function Tarifs({ t, lang }) {
  const [services, setServices] = useState([]);
  const [categoryImages, setCategoryImages] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/services`).then(res => res.json()).then(data => setServices(data)).catch(err => console.error(err));
    fetch(`${API_BASE}/settings`).then(res => res.json()).then(data => {
          setCategoryImages({
              haircut: data.haircut_image, 
              coloring: data.coloring_image, 
              balayage: data.balayage_image,
              lissage: data.lissage_image,
              styling: data.styling_image, 
              treatment: data.treatment_image,
              pack: data.pack_image,
              massageDetente: data.massageDetente_image,
              massageSoins: data.massageSoins_image,
              extras: data.extras_image
          });
      }).catch(err => console.error(err));
  }, []);

  const filteredServices = selectedCategory ? services.filter(s => s.icon === selectedCategory.id) : [];
  const handleBook = (serviceName) => navigate('/booking', { state: { service: serviceName } });
  const getCatImage = (key) => categoryImages[key] ? getImageUrl(categoryImages[key]) : DEFAULT_IMAGES[key];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-slate-50 to-white">
      {/* Bannière élégante */}
      <div className="relative py-12 px-4 bg-gradient-to-br from-slate-900 via-brand-900 to-slate-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yIDItNCAzLTRzMyAyIDMgNHYyYzAgMi0yIDQtMyA0cy0zLTItMy00di0yem0wLTMwYzAtMiAyLTQgMy00czMgMiAzIDR2MmMwIDItMiA0LTMgNHMtMy0yLTMtNFY0ek0wIDM0YzAtMiAyLTQgMy00czMgMiAzIDR2MmMwIDItMiA0LTMgNHMtMy0yLTMtNHYtMnptMC0zMGMwLTIgMi00IDMtNHMzIDIgMyA0djJjMCAyLTIgNC0zIDRzLTMtMi0zLTRWNHoiLz48L2c+PC9nPjwvc3ZnPg==')] animate-pulse"></div>
        </div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center justify-center p-1 mb-4 bg-white/10 backdrop-blur-xl rounded-full border border-white/30 px-4">
            <Sparkles className="h-3 w-3 mr-2 text-brand-300" />
            <span className="text-[9px] font-black uppercase tracking-[0.2em] text-brand-50">
              {t.rates?.badge || 'Services de Prestige'}
            </span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2 font-serif italic tracking-tight">
            {t.rates?.title || 'Nos Tarifs'}
          </h2>
          <p className="text-base text-slate-200 font-medium opacity-90">
            {t.rates?.subtitle || 'Sélectionnez une catégorie pour découvrir nos services'}
          </p>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mb-12">
          {CATEGORIES.map((cat) => (
            <div 
              key={cat.id} 
              onClick={() => setSelectedCategory(cat)} 
              className="cursor-pointer group relative h-80 rounded-[2rem] overflow-hidden shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/40 to-transparent z-10 transition-opacity opacity-80 group-hover:opacity-90" />
              <img 
                  src={getCatImage(cat.key)} 
                  alt={cat.key} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
              />
              <div className="absolute inset-0 z-20 flex flex-col items-center justify-end p-8 text-white">
                <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl mb-4 transform transition-transform duration-500 group-hover:scale-110 group-hover:bg-brand-600/50">
                  <cat.icon className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-extrabold uppercase tracking-widest text-center group-hover:text-brand-300 transition-colors">
                  {t.rates?.categories?.[cat.key] || cat.key}
                </h3>
                <div className="mt-4 flex items-center text-xs font-bold opacity-0 group-hover:opacity-100 transition-all translate-y-4 group-hover:translate-y-0">
                  {t.rates.viewDetails} <ChevronRight className="ml-1 h-3 w-3" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedCategory && (
        <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md z-[100] flex items-center justify-center p-4 transition-all duration-300" onClick={() => setSelectedCategory(null)}>
          <div 
            className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col animate-fade-in-up" 
            onClick={e => e.stopPropagation()}
          >
            <div className="p-8 border-b border-slate-100 flex justify-between items-center bg-white sticky top-0 z-10">
              <div className="flex items-center">
                <div className="bg-brand-50 p-3 rounded-2xl mr-4">
                    <selectedCategory.icon className="h-8 w-8 text-brand-600" />
                </div>
                <div>
                    <h3 className="text-3xl font-black text-slate-800">
                        {t.rates?.categories?.[selectedCategory.key]}
                    </h3>
                    <p className="text-slate-400 text-sm font-medium uppercase tracking-widest">{t.rates.prestigeLabel}</p>
                </div>
              </div>
              <button 
                onClick={() => setSelectedCategory(null)} 
                className="bg-slate-100 p-3 rounded-full text-slate-500 hover:text-brand-600 hover:bg-brand-50 transition-all transform active:scale-90"
              >
                <X className="h-6 w-6" />
              </button>
            </div>
            
            <div className="p-4 md:p-8 overflow-y-auto space-y-6 custom-scrollbar bg-slate-50/30">
              {filteredServices.length > 0 ? (
                filteredServices.map((service, idx) => {
                   const name = service[`name_${lang}`] || service.name_fr || service.name;
                   const desc = service[`description_${lang}`] || service.description_fr || service.description;
                   return (
                      <div 
                        key={service.id} 
                        className="flex flex-col md:flex-row md:items-center justify-between p-6 md:p-8 bg-white rounded-[2rem] hover:shadow-xl transition-all border border-slate-100 group animate-fade-in-up"
                        style={{ animationDelay: `${idx * 100}ms` }}
                      >
                        <div className="flex-1 md:pr-8">
                          <h4 className="font-black text-slate-900 text-2xl group-hover:text-brand-600 transition-colors leading-tight">{name}</h4>
                          <p className="text-slate-500 mt-3 leading-relaxed text-sm max-w-xl font-medium">{desc}</p>
                          <div className="mt-4 inline-flex items-center bg-slate-100 text-slate-600 text-[10px] font-black px-3 py-1.5 rounded-full uppercase tracking-tighter">
                                <Clock className="h-3 w-3 mr-1.5" /> {service.duration} MIN
                          </div>
                        </div>

                        <div className="mt-8 md:mt-0 flex flex-row md:flex-col items-center md:items-end justify-between md:justify-center border-t md:border-t-0 md:border-l border-slate-100 pt-6 md:pt-0 md:pl-8 min-w-[180px]">
                            <div className="flex flex-col md:items-end mb-0 md:mb-4">
                                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">{t.rates.priceLabel}</span>
                                <span className="text-slate-900 font-black text-3xl leading-none">{parseFloat(service.price).toFixed(2)}€</span>
                            </div>
                            <button 
                                onClick={() => handleBook(name)} 
                                className="px-8 py-4 bg-brand-600 text-white rounded-2xl font-black text-sm tracking-widest hover:bg-brand-700 transition-all shadow-lg hover:shadow-brand-500/20 transform active:scale-95 flex items-center justify-center whitespace-nowrap min-h-[56px]"
                            >
                                {t.rates?.bookBtn || 'RÉSERVER'} <ChevronRight className="ml-2 h-4 w-4" />
                            </button>
                        </div>
                      </div>
                   );
                })
              ) : (
                <div className="text-center py-20 bg-white rounded-3xl border-2 border-dashed border-slate-200">
                  <div className="bg-slate-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 text-slate-300">
                    <Scissors className="h-10 w-10" />
                  </div>
                  <p className="text-slate-400 font-bold text-xl uppercase tracking-widest">{t.rates.noService}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}